import { EntityLayout } from '@backstage/plugin-catalog';
import { commonOverviewContent, commonRoutes } from './common';

export const componentPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {commonOverviewContent}
    </EntityLayout.Route>
    {...commonRoutes}
  </EntityLayout>
);
